import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';

import { ConsentCheckboxState } from '../../../utilities/marketing-consent';

export type LoginMarketingConsentContextProps = {
  marketingConsent: ConsentCheckboxState | undefined;
  setMarketingConsent: (_: ConsentCheckboxState) => void;
};

const MarketingConsentContext = createContext<LoginMarketingConsentContextProps | null>(null);

export const MarketingConsentContextProvider = ({ children }: { children: ReactNode }) => {
  const [marketingConsent, setMarketingConsent] = useState<ConsentCheckboxState | undefined>(
    undefined
  );

  const value = useMemo(
    (): LoginMarketingConsentContextProps => ({
      marketingConsent,
      setMarketingConsent,
    }),
    [marketingConsent, setMarketingConsent]
  );
  return (
    <MarketingConsentContext.Provider value={value}>{children}</MarketingConsentContext.Provider>
  );
};

export const useMarketingConsentContext = () => {
  const context = useContext(MarketingConsentContext);

  if (!context) {
    throw new Error(
      'useMarketingConsentContext must be used within MarketingConsentContextProvider'
    );
  }

  return context;
};
